import { FvButton } from '@fv/client-components'

import { ShipperTooltip } from '@/components/ShipperTooltip'
import { useCurrentUser } from '@/hooks/settings/useAppContext'

import { useSubscribeToThread } from './mutations'
import { useLoadMessages } from './queries'

type Props = {
  loadId: string
  carrierId: string
}
export const SubscribeButton = (props: Props) => {
  const { loadId, carrierId } = props
  const user = useCurrentUser()
  const subscribeToThread = useSubscribeToThread(loadId, carrierId)
  const { data: messages } = useLoadMessages({
    loadId,
    carrierId,
  })

  // Check if user is already a participant in any message in this thread
  const isSubscribed =
    messages?.some(message =>
      message.participants.some(participant => participant.id === user._id),
    ) ?? false

  const handleClick = async () => {
    if (!isSubscribed) {
      await subscribeToThread.mutateAsync()
    }
  }

  return (
    <ShipperTooltip
      label={
        isSubscribed
          ? `You're subscribed to this thread`
          : 'Subscribe to new messages'
      }
    >
      <FvButton
        icon={isSubscribed ? 'bell-on' : 'bell'}
        onClick={handleClick}
        disabled={isSubscribed || subscribeToThread.isPending}
        loading={subscribeToThread.isPending}
      />
    </ShipperTooltip>
  )
}
